<!--
  IGNTR sidebar user card. Lives at the bottom of <app-sidebar>; all data
  (display name, email, image, tenant) and click handlers (profile link,
  logout) are unchanged from the previous implementation.
-->
<div
  *ngIf="generalDataRepo.allGeneralData$ | async as data"
  class="flex items-center gap-2.5 px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] text-white"
>
  <a
    routerLink="/profile"
    (click)="handleClick($event)"
    class="shrink-0"
    aria-label="Open profile"
  >
    <app-entity-avatar-init
      [img]="data.activeUserData.imagePath"
      [name]="data.activeUserData.userName"
      [surname]="data.activeUserData.surname"
    ></app-entity-avatar-init>
  </a>

  <div class="min-w-0 flex-1">
    <div class="truncate text-[12.5px] font-medium text-white">
      {{ data.activeUserData.displayName }}
    </div>
    <div class="truncate font-mono text-[11px] text-white/45">
      {{ data.activeUserData.email }}
    </div>
  </div>

  <button
    type="button"
    (click)="logout()"
    class="rounded p-1 text-white/40 transition hover:bg-white/5 hover:text-white/80"
    aria-label="Log out"
    title="Log out"
  >
    <igntr-icon name="logout" [size]="16"></igntr-icon>
  </button>
</div>
